import styled from 'styled-components';

export const Refresh = styled.button`
  position: absolute;
  right: 10px;
  top: 9px;
  border: 0;
  z-index: 15;
  border-radius: 10px;
  width: 34px;
  height: 34px;
  background: rgba(51, 51, 51, 0.6) url('/images/rebut.png') no-repeat 50% 50%;
  transition: all 0.3s ease-in;
  cursor: pointer;
  &:hover {
    background-color: #111;
  }
`;

export const Save = styled(Refresh)`
  background-color: rgba(170, 170, 170, 0.6);
  background-image: url('/images/takefoto.png');
  background-size: 16px auto;
  right: auto;
  left: 10px;
  &:hover {
    background-color: #eee;
  }
`;

export const Videos = styled.div`
  width: 500px;
  transform: translateY(4px);
  padding: 2px 0 0px 5px;
`;

export const Container = styled.div`
  position: relative;
  display: block;
  height: 100%;
  height: ${(props) => props.height};
  /* z-index: 10; */
  overflow: hidden;
  img {
    border-radius: 10px;
    &.error-img {
      height: auto;
      width: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  //background-color: #a9a9a9;
`;

export const Main = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  img {
    /* height: 98%; */
    /* width: 99%; //auto; */
    height: 98%;
    width: 100%;
  }
`;

export const Selector = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  right: 10px;
  z-index: 2;
  overflow: auto;
  display: flex;
  .img-block,
  img {
    box-sizing: border-box;
    display: block;
    width: auto;
    min-width: 92px;
    height: 60px !important;
    border-radius: 5px;
  }
  img {
    cursor: pointer;
    opacity: 0.7;
    transition: 0.2s all ease-in;
    border: 1px solid #000;
    &.active {
      border: 1px solid #fff;
      opacity: 1;
      cursor: default;
    }
    &:hover {
      opacity: 1;
    }
  }
  .img-block {
    margin-right: 5px;
    &:after {
      border-radius: 5px;
    }
  }
`;
